package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminFixtureResponse(
    val id: String,
    @SerialName("vendor_fixture_id") val vendorFixtureId: String,
    @SerialName("league_id") val leagueId: String,
    @SerialName("league_name") val leagueName: String?,
    @SerialName("home_team_name") val homeTeamName: String?,
    @SerialName("away_team_name") val awayTeamName: String?,
    val status: String,
    @SerialName("kickoff_at_utc") val kickoffAtUtc: String?,
    @SerialName("home_score") val homeScore: Int?,
    @SerialName("away_score") val awayScore: Int?,
    @SerialName("season_year") val seasonYear: Int,
    @SerialName("synced_at_utc") val syncedAtUtc: String
)
